import $ from 'jquery';
import Cookies from 'js-cookie';

const $document = $(document);
const $html = $('html');

const $takeover = $('.js-takeover');
const $takeoverBackground = $takeover.find('.js-takeover-background');
const $takeoverContainer = $takeover.find('.js-takeover-container');
const $takeoverClose = $takeover.find('.js-takeover-close');

const takeoverCookieName = String($takeover.attr('data-cookie-name'));
const takeoverCookieDuration = Number($takeover.attr('data-cookie-duration'));

function takeoverOpen() {
  $takeover.removeClass('is-closing is-closed');
  $takeover.addClass('is-opening');
  $html.attr('data-takeover', 'is-opening');

  setTimeout(() => {
    $takeover.removeClass('is-opening');
    $takeover.addClass('is-opened');
    $html.attr('data-takeover', 'is-opened');
  }, 400);
}

function takeoverClose(event) {
  Cookies.set(takeoverCookieName, true, { expires: takeoverCookieDuration });

  $takeover.removeClass('is-opening is-opened');
  $takeover.addClass('is-closing');
  $html.attr('data-takeover', 'is-closing');
  setTimeout(() => {
    $takeover.removeClass('is-closing');
    $takeover.addClass('is-closed');
    $html.attr('data-takeover', 'is-closed');
  }, 400);
}

// Open modal if it hasn't previously
if ($takeover.length && !Cookies.get(takeoverCookieName)) {
  takeoverOpen();
}

// Close overlay when clicking background
$takeoverBackground.on('click', takeoverClose);

// Close when clicking "x" button
$takeoverClose.on('click', takeoverClose);

// Close when hitting ESC key
$document.keyup(function (e) {
  if (e.key === 'Escape') takeoverClose();
});
